/**
 * @module components/StackedLimit
 * @description 堆叠层展示限制 — UI 复用 TopNFieldGroup，状态见 useStackedTopNDraftFields
 */
import React from 'react';
import { useIntl } from 'umi';
import ConfigCollapseCard from '@/pages/datalab/components/ConfigCollapseCard';
import TopNFieldGroup from '../common/TopNFieldGroup';
import { useStackedTopNDraftFields } from '../common/TopNFieldGroup/useStackedTopNDraftFields';

const StackedLimit: React.FC = () => {
  const { formatMessage } = useIntl();
  const stackedTopN = useStackedTopNDraftFields();

  return (
    <ConfigCollapseCard
      title={formatMessage({ id: 'dbl_chart_stacked_layer_display_limit' })}
      info={{ tipText: formatMessage({ id: 'dbl_chart_stacked_limit_info' }) }}
      defaultActiveIds={['1']}
    >
      <TopNFieldGroup
        {...stackedTopN}
        countMax={500}
        countLimitTip={formatMessage({ id: 'dbl_myAnalysis_limit_500' })}
      />
    </ConfigCollapseCard>
  );
};

export default React.memo(StackedLimit);
